import "./App.css";
import "./styles.css";
// import "./components/socialIcons";
import Homepage from "./components/Homepage";
import Myorders from "./components/Myorders";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    //sticky top-0 z-50
    <div className="App">
      <div className="body">
        <div className="header ">
          <div className="header-top">
            Rossey Patisserie
            <div className="header-bottom"></div>
          </div>
        </div>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/mymy" element={<Myorders />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
